import styled, { css } from 'styled-components';

export const ButtonsWrapper = styled.div<{ $layout: 'stacked' | 'inline' }>(
  ({ theme, $layout }) => css`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: ${theme.sz.s4};
    width: 100%;

    ${
      $layout === 'inline' &&
      css`
        align-self: center;
        max-width: ${theme.sz.s64};
      `
    }
  `,
);
